import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const CSS = ``;

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', senha: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.senha);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{CSS}</style>

      <div style={{
        minHeight: '100vh',
        display: 'flex',
        background: 'var(--gradient-diagonal)',
        overflow: 'hidden',
      }}>

        {/* ── Esquerda: branding ────────────────────────────────── */}
        <div className="d-none d-md-flex flex-column justify-content-between p-5"
             style={{ flex: 1, color: '#fff' }}>

          {/* Topo vazio */}
          <div />

          {/* Centro: nome + descritivo */}
          <div>
            <div style={{
              fontSize: 'clamp(4rem, 9vw, 8rem)',
              fontWeight: 900,
              letterSpacing: '-.04em',
              lineHeight: 1,
              marginBottom: '1.25rem',
              textShadow: '0 4px 32px rgba(0,0,0,.18)',
            }}>
              FENIX
            </div>
            <div style={{
              width: 48, height: 3,
              background: 'rgba(255,255,255,.45)',
              borderRadius: 99,
              marginBottom: '1.25rem',
            }} />
            <p style={{
              fontSize: 'clamp(.95rem, 1.8vw, 1.15rem)',
              opacity: .82,
              lineHeight: 1.65,
              maxWidth: 360,
              margin: 0,
              fontWeight: 400,
            }}>
              Plataforma de gestão de Fit Tests auditivos e respiratórios para trabalhadores offshore.
            </p>
          </div>

          {/* Rodapé: crédito Datafit */}
          <div style={{ textAlign: 'center', opacity: .45, fontSize: '.8rem', letterSpacing: '.04em' }}>
            Desenvolvido por <strong style={{ fontWeight: 600 }}>Datafit</strong>
          </div>
        </div>

        {/* ── Direita: card colado na borda ─────────────────────── */}
        <div style={{
          width: '100%',
          maxWidth: 440,
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '3rem 2.5rem',
          borderRadius: '20px 0 0 20px',
          boxShadow: '-16px 0 60px rgba(0,0,0,.2)',
        }}>
          <div style={{ width: '100%', maxWidth: 360 }}>

            {/* Logo mobile (só aparece quando esquerda some) */}
            <div className="d-md-none text-center mb-5">
              <div className="navbar-brand-gradient fs-2 fw-bold">
                <i className="bi bi-shield-check me-2"></i>FitTest
              </div>
            </div>

            {/* Cabeçalho do form */}
            <div className="mb-4">
              <div className="d-flex align-items-center gap-2 mb-3">
                <div style={{
                  width: 34, height: 34, borderRadius: 10,
                  background: 'var(--gradient-diagonal)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  boxShadow: '0 3px 10px rgba(82,0,255,.3)',
                }}>
                  <i className="bi bi-shield-check" style={{ color: '#fff', fontSize: '.9rem' }}></i>
                </div>
                <span style={{
                  fontWeight: 700, fontSize: '.9rem',
                  background: 'var(--gradient-diagonal)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}>
                  FitTest
                </span>
              </div>
              <h2 style={{ fontWeight: 700, fontSize: '1.5rem', marginBottom: '.25rem' }}>
                Bem-vindo de volta
              </h2>
              <p className="text-muted mb-0" style={{ fontSize: '.875rem' }}>
                Entre com suas credenciais para acessar o portal.
              </p>
            </div>

            {error && (
              <div className="alert alert-danger py-2 small mb-3" role="alert">
                <i className="bi bi-exclamation-triangle me-2"></i>{error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-floating mb-3">
                <input
                  type="email" className="form-control" id="email"
                  placeholder="email@empresa.com"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required autoFocus
                />
                <label htmlFor="email">E-mail</label>
              </div>
              <div className="form-floating mb-4">
                <input
                  type="password" className="form-control" id="senha"
                  placeholder="Senha"
                  value={form.senha}
                  onChange={(e) => setForm({ ...form, senha: e.target.value })}
                  required
                />
                <label htmlFor="senha">Senha</label>
              </div>
              <button
                type="submit"
                className="btn-datafit w-100 d-flex align-items-center justify-content-center"
                disabled={loading}
              >
                {loading
                  ? <span className="spinner-border spinner-border-sm me-2" />
                  : <i className="bi bi-box-arrow-in-right me-2"></i>
                }
                Entrar
              </button>
            </form>

            <div className="text-center mt-4" style={{ paddingTop: '1rem', borderTop: '1px solid #f0f2f5' }}>
              <span style={{ fontSize: '.75rem', color: '#c4c9d4' }}>
                Datafit © {new Date().getFullYear()}
              </span>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
